import {
    createHandlerChainRunner,
    HasOnComplete,
} from "@insite/client-framework/HandlerCreator";
import { getBranches, ProvinceModel } from "@WhiteCap/Services/ContactUsLocationsService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";


// Types
export interface BranchModel {
    id: string;
    name: string;
}

type HandlerType = CustomApiHandler<{}, { provinces: ProvinceModel[] }> & HasOnComplete;


//Begin
export const DispatchBeginLoadBranches: HandlerType = props => {
    props.dispatch({
        type: "Custom/Branches/BeginLoadBranches",
    });
};


// Prepare API params (empty for now)
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {};
};


//Call API
export const RequestBranchesFromApi: HandlerType = async props => {
    try {
        const response = await getBranches(props.apiParameter);

        props.apiResult = {
            provinces: response || [],
        };
    } catch (error) {
        props.dispatch({
            type: "Custom/Branches/FailedLoadBranches",
        });
    }
};

//Complete
export const DispatchCompleteLoadBranches: HandlerType = props => {
    if (!props.apiResult) return;

    props.dispatch({
        type: "Custom/Branches/CompleteLoadBranches",
        result: props.apiResult,
    });
};


// Chain
export const chain = [
    DispatchBeginLoadBranches,
    PopulateApiParameter,
    RequestBranchesFromApi,
    DispatchCompleteLoadBranches,
];

const loadBranches = createHandlerChainRunner(chain, "LoadBranches");

export default loadBranches;